import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/sentry'
import './plugins/axios'
import './plugins/fontawesome'
import './plugins/bootstrap-vue'
import './plugins/perfect-scrollbar'
import './plugins/vue-auth'
import './plugins/vue-body-class'
import './plugins/v-calendar'
import './plugins/vuelidate'
import './plugins/vue-numeral'
import './plugins/portal-vue'
import './plugins/vue-good-table'
import './plugins/vue-cookies'
// import './plugins/gtm'
import App from './App.vue'
import router from './routers'
import store from './store'
import VueGtag from 'vue-gtag'
import { createProvider } from './vue-apollo'
import InlineLoading from './components/shared/InlineLoading'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.config.productionTip = false
Vue.component('inline-loading', InlineLoading)
Vue.use(VueSweetalert2)
Vue.use(VueGtag, {
  config: { id: 'G-1JXEJ1F1NP' }
}, router)

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
